import {onSelectAnnotationOnMap} from "./annotations_app_utils";
import {
    retrieveAnnotations,
    updateAnnotationVector, updateDeepBioResultVector,
    updateDeepBioVector, updateBloodAnnotationVector, retrieveBloodAnnotations
} from "../../../action/maps.state.action";


// Type of Layer is Mandatory (choose between blood and tissue)

export const getAnnotationAppLayer = (gammaState) => {
    return {
        name: "Annotations Layer",
        map_name: "annotation_layer",
        anno_drawer: 0,
        type: 'tissue',
        permission: gammaState.appsInstalled["annotations_installed"],
        store: updateAnnotationVector,
        loadDataOnRender: true,
        dataLoad: retrieveAnnotations,
        onSelectAnnotationOnMap: (annotationId) => onSelectAnnotationOnMap("annotations", annotationId),
        selectInteraction: true,
    }
}

export const getDeepBioAppDrawerLayer = (gammaState) => {
    return {
        name: "DeepBio Layer",
        map_name: "deepbio_layer",
        anno_drawer: 1,
        type: 'tissue',
        permission: gammaState.appsInstalled["deep_bio_installed"],
        store: updateDeepBioVector,
        loadDataOnRender: true,
        dataLoad: retrieveAnnotations,
        onSelectAnnotationOnMap: (annotationId) => onSelectAnnotationOnMap("deep_bio", annotationId),
        selectInteraction: false,
    }
}

export const getDeepBioAppResultLayer = (gammaState) => {
    return {
        name: "DeepBio Analysis",
        map_name: "deep_bio_analysis",
        anno_drawer: 2,
        type: 'tissue',
        store: updateDeepBioResultVector,
        permission: gammaState.appsInstalled["deep_bio_installed"],
        loadDataOnRender: false,
        dataLoad: undefined,
        dataLoadArguments: undefined,
        onSelectAnnotationOnMap: undefined,
        selectInteraction: false,
    }
}

export const getBloodAnnotationLayer = (gammaState) => {
    return {
        name: "Blood Annotations",
        map_name: "blood_annotation_layer",
        anno_drawer: 5,
        type: 'blood',
        permission: gammaState.appsInstalled["blood_annotations_installed"],
        store: updateBloodAnnotationVector,
        loadDataOnRender: true,
        dataLoad: (mapId, slideId) => retrieveBloodAnnotations(mapId, slideId),
        onSelectAnnotationOnMap: (annotationId) => onSelectAnnotationOnMap("blood_annotations", annotationId),
        selectInteraction: true,
    }
}

export const getAllLayers = (gammaState) => {
    return [
        getAnnotationAppLayer(gammaState),
        getDeepBioAppDrawerLayer(gammaState),
        getDeepBioAppResultLayer(gammaState),
        getBloodAnnotationLayer(gammaState),
    ];
}
